import React, { useState } from "react";
import { ShowAlert } from "../../../common/alert";
import EditCont from "../container/EditCont";
import { withRouter } from "react-router";
import NoteDetails from "./noteDetailsComponent";

const TemplateNDicationComp = (props) => {
   const {
      SummaryData,
      noteId,
      signedUrl,
      GetNotes = () => {},
      getGeneratedNotes = () => {},
      dictationLoading,
      templateData,
      loading,
      activeTab,
      deleteNotes,
      setShowDeletePopup,
      isVimProvider,
   } = props;
   const [editComponent, setEditComponent] = useState(false);
   const note = SummaryData?.notes || null;
   const title = SummaryData?.title?.length === 0 || SummaryData.length === 0 ? "Clinical Note" : SummaryData?.title;
   const NoteId = SummaryData?.id || noteId;
   const dictation = signedUrl?.dictation || "";

   const copyContent = (text) => {
      navigator.clipboard
         .writeText(text)
         .then(() => {
            ShowAlert("Copied to clipboard.");
         })
         .catch((error) => {
            ShowAlert("Error copying messages", "error");
         });
   };
   function removeHashAndAsterisk(text) {
      if (typeof text !== "string") {
         return "Please provide a valid string.";
      }
      const modifiedText = text.replace(/[#*]/g, "");
      return modifiedText;
   }
   const modifiedText = note;
   return (
      <div className={`d-relative  ${editComponent ? "temp-diction-container-edit" : "epic-temp-diction-container"}`}>
         {templateData?.loading === true || loading === true || dictationLoading === true ? (
            <div
               style={{ width: "100%", height: "90vh" }}
               class="d-flex justify-content-center align-items-center text-center"
            >
               <div class="d-flex justify-content-center">
                  <div
                     style={{ width: "8rem", height: "8rem" }}
                     className="spinner-border  loader-color text-center"
                  ></div>
               </div>
            </div>
         ) : (
            <>
               {!editComponent ? (
                  <NoteDetails
                     isVimProvider={isVimProvider}
                     setShowDeletePopup={setShowDeletePopup}
                     deleteNotes={deleteNotes}
                     setEditComponents={() => {
                        setEditComponent(true);
                     }}
                     editComponent={editComponent}
                     {...props}
                  />
               ) : (
                  <EditCont
                     note={note}
                     NoteId={NoteId}
                     setEditComponent={setEditComponent}
                     modifiedText={modifiedText}
                     title={title}
                     getGeneratedNotes={getGeneratedNotes}
                     GetNotes={GetNotes}
                  />
               )}
            </>
         )}
      </div>
   );
};

export default withRouter(TemplateNDicationComp);
